import React from "react";
import { useFormikContext, getIn } from "formik";
import getDisplayName from "../utils/getDisplayName";
// import { useValidationContext } from '../contexts/ValidationContext'; 

const extendClassName = props => {
  const { name, className = "" } = props;
  if (!name) {
    return className;
  }

  const classNames = className.split(" ").filter(c => c !== "");
  const { touched, errors } = useFormikContext();

  if (getIn(touched, name)) {
    classNames.push("touched");
  }
  if (getIn(errors, name)) {
    classNames.push("error");
  }
  return classNames.join(" ");
};

export default function withFormikAwareClassName(WrappedComponent) {
  const WithFormikAwareClassName = props => (
    <WrappedComponent {...props} className={extendClassName(props)} />
  );
  WithFormikAwareClassName.displayName = `WithFormikAwareClassName(${getDisplayName(
    WrappedComponent
  )})`;
  return WithFormikAwareClassName;
}
